export const ColoredDivider = () => (
    <div className='h-2 w-full bg-[#f9e364] my-2' />
)
export const ColoredDividerThin = () => (
    <div className='h-1 w-full bg-[#f9e364] my-2' />
)